import React from 'react';
import classnames from 'classnames';
import { withTranslation, WithTranslation } from 'react-i18next';
import EmptyState from '../../../../EmptyState';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import {
  withVerification,
  WithVerificationProps,
} from '@wix/da-shared-react/pkg/VerificationPopup/withVerification';
import {
  withLogBiEvent,
  WithLogBiEventProps,
} from '@wix/da-shared-react/pkg/biLogger/hocs/withLogBiEvent';
import { VerificationRequiredActions } from '@wix/da-shared-react/pkg/publicSession/types';

import noop from '@wix/da-shared-react/pkg/utils/noop';
import { BiEventType } from '@wix/da-shared-react/pkg/biLogger';

import s from './EmptyState.scss';

export interface Props {
  postType: 'poll' | 'status' | 'journal' | 'journalDraft';
  view?: 'large' | 'small' | 'wide';
  isOwner: boolean;
  username?: string;
  CTAButtonModalType?: ModalType;
  className?: string;
  openSubmitPostPopup?: () => void;
}

export class PostsEmptyState extends React.Component<
  Props & WithTranslation & WithVerificationProps & WithLogBiEventProps
> {
  render() {
    const {
      view,
      isOwner,
      username,
      postType,
      CTAButtonModalType,
      className,
      t,
    } = this.props;

    return (
      <EmptyState
        view={view}
        className={classnames(
          s['root'],
          view === 'large' && s['large'],
          className
        )}
        title={
          isOwner
            ? t!(`pages.posts.emptyState.${postType}.title.owner`)
            : t!(`pages.posts.emptyState.${postType}.title.visitor`, {
                username,
              })
        }
        subtitle={
          isOwner
            ? t!(`pages.posts.emptyState.${postType}.subtitle.owner`)
            : t!(`pages.posts.emptyState.${postType}.subtitle.visitor`, {
                username,
              })
        }
        buttonLabel={
          CTAButtonModalType &&
          t!(`pages.posts.emptyState.${postType}.createCTA`)
        }
        onButtonClick={this.handleButtonClick}
        withButton={isOwner}
      />
    );
  }

  getVerificationPopupType(): VerificationRequiredActions {
    const { postType } = this.props;
    switch (postType) {
      case 'journal':
      case 'journalDraft':
        return 'submitjournal';
      case 'poll':
        return 'submitpoll';
      case 'status':
        return 'submitstatus';
      default:
        return 'submit';
    }
  }

  handleButtonClick = () => {
    const {
      postType,
      CTAButtonModalType,
      logBiEvent,
      pushVerificationPopup,
      isVerificationNeeded,
      openSubmitPostPopup = noop,
    } = this.props;

    if (!CTAButtonModalType) {
      return null;
    }

    if (isVerificationNeeded) {
      pushVerificationPopup(this.getVerificationPopupType());
    } else {
      openSubmitPostPopup();
      logBiEvent({
        evid: BiEventType.ADD_NEW_CONTENT_CLICK,
        widgetname: `${postType}_emptystate`,
      });
    }
  };
}

export default withVerification(
  withLogBiEvent(withTranslation()(PostsEmptyState))
);
